const features = [
  {
    icon: 'ri-shield-check-line',
    label: 'PROTECTION',
    title: 'Enhanced Security',
    description:
      'Our applications use military-grade AES-256 encryption to protect your data and online activity from hackers, trackers, and surveillance.',
    image: 'https://public.readdy.ai/ai/img_res/8e18e34420a09f68ec1683898c0bd74c.jpg',
  },
  {
    icon: 'ri-speed-up-line',
    label: 'SPEED',
    title: 'Optimized Performance',
    description:
      'Built with performance at the core, our apps run efficiently in the background without draining your battery or slowing down your device.',
    image: 'https://readdy.ai/api/search-image?query=high%20speed%20performance%20visualization%2C%20abstract%20flowing%20light%20trails%20on%20dark%20background%2C%20teal%20and%20white%20color%20scheme%2C%20dynamic%20motion%20blur%20effect%2C%20modern%20tech%20art%2C%20clean%20minimal%20aesthetic&width=600&height=400&seq=feat002&orientation=landscape',
  },
  {
    icon: 'ri-user-heart-line',
    label: 'DESIGN',
    title: 'Intuitive Interface',
    description:
      'Every screen is thoughtfully designed to make powerful features accessible to all users, regardless of their technical background.',
    image: 'https://readdy.ai/api/search-image?query=clean%20iOS%20app%20user%20interface%20design%2C%20minimal%20white%20and%20teal%20color%20palette%2C%20intuitive%20mobile%20UX%20layout%2C%20modern%20flat%20design%20elements%2C%20professional%20app%20design%20mockup%2C%20light%20background&width=600&height=400&seq=feat003&orientation=landscape',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 md:py-36 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#00d4aa] text-xs font-bold tracking-[4px] uppercase mb-4">Why Choose Us</p>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 leading-tight">
            Key <span className="italic font-light text-gray-400">Features</span>
          </h2>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat) => (
            <div key={feat.title} className="bg-white rounded-2xl overflow-hidden flex flex-col">
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={feat.image}
                  alt={feat.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#00d4aa]/10 shrink-0">
                    <i className={`${feat.icon} text-[#00d4aa] text-lg`} />
                  </div>
                  <span className="text-[10px] font-bold tracking-[3px] text-[#00d4aa] uppercase">
                    {feat.label}
                  </span>
                </div>
                <h3 className="text-xl font-black text-gray-900 mb-3">{feat.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 rounded-3xl bg-gradient-to-br from-[#0d1b2a] to-[#1a3a5c] p-10 md:p-14 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-3xl md:text-4xl font-black text-white mb-4">
              Built for the Modern Mobile User
            </h3>
            <p className="text-white/60 text-base leading-relaxed max-w-xl">
              AKIAN DOO products are engineered to meet the highest standards of quality, security,
              and usability — giving users the tools they need to stay safe and productive.
            </p>
          </div>
          <div className="flex flex-wrap gap-6 justify-center md:justify-end shrink-0">
            {[
              { icon: 'ri-smartphone-line', label: 'Mobile Native' },
              { icon: 'ri-lock-2-line', label: 'Encrypted' },
              { icon: 'ri-customer-service-2-line', label: 'Supported' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/10">
                  <i className={`${item.icon} text-[#00d4aa] text-2xl`} />
                </div>
                <span className="text-white/70 text-xs font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
